import Axios from 'axios';
import store from '../store';

import {
	CLEAR_FILES_SINGLE_ERROR,
	CLEAR_ALL_FILES_ERRORS,
	SET_FILE_ID,
	FILE_SAVE_LOADING,
	FILE_SAVE_ERROR,
	ALL_FILES_LOADING,
	ALL_FILES_GET,
	ALL_FILES_ERROR,
	FILE_INFO_LOADING,
	FILE_INFO_GET,
	FILE_INFO_ERROR,
	FILE_DELETE_LOADING,
	DOWNLOAD_FILE_LOADING,
	FILE_LOGS_LOADING,
	FILE_LOGS_GET,
	FILE_LOGS_ERROR
} from './types';

// Utils
import create_query_params from '../utils/create_query_params';
import add_key_prop from '../utils/add_key_prop';

export const clear_files_errors = (key) => dispatch => {
	if (key) {
		dispatch({
			type: CLEAR_FILES_SINGLE_ERROR,
			payload: key
		});
	}
	else {
		dispatch({
			type: CLEAR_ALL_FILES_ERRORS
		});
	}
}

export const set_file_id = (fileId) => dispatch => {
	dispatch({
		type: SET_FILE_ID,
		payload: fileId
	});
}

export const file_create = (fileBody) => dispatch => {
	dispatch(clear_files_errors('file_create'));

	dispatch({
		type: FILE_SAVE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/training/files/create';

	Axios.post(url, fileBody)
	.then((res) => {
		// console.log(res.data);
		dispatch(set_file_id(res.data.file));

		dispatch({
			type: FILE_SAVE_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: FILE_SAVE_ERROR,
			payload: { type: 'file_create', msg: err.message }
		});

		dispatch({
			type: FILE_SAVE_LOADING,
			payload: false
		});
	})
}

export const file_upload = (options, reload) => dispatch => {
	const { file, onSuccess, onError, action, onProgress } = options;
	
	onProgress({ percent: 0 }, file);
	
	const formData = new FormData();
	formData.append('file', file);

	Axios.post(action, formData, {
		headers: { 'Content-Type': 'multipart/form-data' }
	})
	.then((res) => {
		// console.log(res.data);
		onSuccess(res.data, file);

		if (reload) {
			window.location.reload();
		}
	}).catch((err) => {
		// console.log(err);
		onError(new Error(store.getState().global?.global_data?.files?.uploadError));
	})
}

export const get_all_files = (filters) => dispatch => {
	dispatch(clear_files_errors('all_files'));

	dispatch({
		type: ALL_FILES_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/training/files?' + create_query_params(filters);

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		const newFilesArray = add_key_prop(res.data.files);

		dispatch({
			type: ALL_FILES_GET,
			payload: { count: res.data.count, files: newFilesArray }
		});

		dispatch({
			type: ALL_FILES_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_FILES_ERROR,
			payload: { type: 'all_files', msg: err.message }
		});

		dispatch({
			type: ALL_FILES_LOADING,
			payload: false
		});
	})
}

export const get_file_info = (file_id) => dispatch => {
	dispatch(clear_files_errors('file_info'));

	dispatch({
		type: FILE_INFO_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/training/files/${file_id}/info`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		dispatch({
			type: FILE_INFO_GET,
			payload: res.data
		});

		dispatch({
			type: FILE_INFO_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: FILE_INFO_ERROR,
			payload: { type: 'file_info', msg: err.message }
		});

		dispatch({
			type: FILE_INFO_LOADING,
			payload: false
		});
	})
}

export const file_update = (messageApi, fileId, fileBody, handleCancel) => dispatch => {
	dispatch({
		type: FILE_SAVE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/training/files/${fileId}/update`;

	Axios.put(url, fileBody)
	.then((res) => {
		// messageApi.success(i18next.t('worlds.edit.successAlert'), 4);

		dispatch({
			type: FILE_SAVE_LOADING,
			payload: false
		});
		
		handleCancel();
	}).catch((err) => {
		// console.log(err.response.status);
		dispatch({
			type: FILE_SAVE_ERROR,
			payload: { type: 'file_update', msg: err.message }
		});

		dispatch({
			type: FILE_SAVE_LOADING,
			payload: false
		});
	})
}

export const file_delete = (messageApi, global_data, fileId, filters) => dispatch => {
	dispatch({
		type: FILE_DELETE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/training/files/${fileId}/remove`;

	Axios.delete(url)
	.then((res) => {
		messageApi.success(global_data?.files?.deleteSuccessAlert, 4);

		dispatch({
			type: FILE_DELETE_LOADING,
			payload: false
		});

		dispatch(get_all_files(filters));
	}).catch((err) => {
		// console.log(err);
		messageApi.error(global_data?.files?.deleteErrorAlert, 4);

		dispatch({
			type: FILE_DELETE_LOADING,
			payload: false
		});
	})
}

export const download_file = (messageApi, global_data, file_id, fileName) => dispatch => {
	dispatch({
		type: DOWNLOAD_FILE_LOADING,
		payload: { fileId: file_id, loading: true }
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/training/files/${file_id}/data`;

	Axios.get(url, {
		responseType: 'blob'
	})
	.then((res) => {
		dispatch({
			type: DOWNLOAD_FILE_LOADING,
			payload: { fileId: file_id, loading: false }
		});

		const blob = new Blob([res.data]);
		const downloadURL = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = downloadURL;
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link); // Remove the element after download
		URL.revokeObjectURL(downloadURL); // Free memory
	})
	.catch((err) => {
		// console.error(err);
		messageApi.error(global_data?.files?.downloadError, 4);

		dispatch({
			type: DOWNLOAD_FILE_LOADING,
			payload: { fileId: file_id, loading: false }
		});
	})
}

export const get_file_logs = (filters) => dispatch => {
	dispatch(clear_files_errors('file_logs'));

	dispatch({
		type: FILE_LOGS_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/training/logs?' + create_query_params(filters);

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		const newLogsArray = add_key_prop(res.data.logs);

		dispatch({
			type: FILE_LOGS_GET,
			payload: { count: res.data.count, logs: newLogsArray }
		});

		dispatch({
			type: FILE_LOGS_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: FILE_LOGS_ERROR,
			payload: { type: 'file_logs', msg: err.message }
		});

		dispatch({
			type: FILE_LOGS_LOADING,
			payload: false
		});
	})
}
